module.exports = __webpack_public_path__ + "img/youpin.8f2cd392.png";